'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _pack = require('../base/pack');

var _pack2 = _interopRequireDefault(_pack);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axios = _util2.default.axios,
    levelText = _util2.default.levelText;

var Pack = function (_BasePack) {
  (0, _inherits3.default)(Pack, _BasePack);

  function Pack(data) {
    (0, _classCallCheck3.default)(this, Pack);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Pack.__proto__ || (0, _getPrototypeOf2.default)(Pack)).call(this, data));

    _this.setLevelText();
    return _this;
  }

  (0, _createClass3.default)(Pack, [{
    key: 'setLevelText',
    value: function setLevelText() {
      this.data.spv.levelText = levelText(this.data.spv.levelIds);
    }
  }, {
    key: 'setVariant',
    value: function setVariant(_ref) {
      var _this2 = this;

      var result = _ref.result,
          variant = _ref.variant;

      return this.modifyVariant(result).then(function () {
        variant.spvs.forEach(function (spv) {
          if (spv.id === result.spvId) {
            _this2.data.spv = spv;
          }
        });
        _this2.setSpvDescText();
        _this2.setLevelText();
      });
    }
  }, {
    key: 'modify',
    value: function modify(data) {
      return axios({
        url: '/app/exchange/cart/packs',
        method: 'PUT',
        json: data
      });
    }
  }]);
  return Pack;
}(_pack2.default);

exports.default = Pack;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/points/pack.js
// module id = 862
// module chunks = 0